import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  dealStats: {},
  dealStatsAreLoaded: false,

  convertationOptions: [],
  convertationOptionsAreLoaded: false,

  lpaAgreements: [],
  lpaAgreementsAreLoaded: false,

  createdAccount: {},

  outerVerifyExternalLink: null,
  outerVerifyExternalLinkIsLoaded: false,

  accountTradeLink: '',
  accountTradeLinkLoading: false,
  accountTradeLinkLoaded: false,

  analytics: {},
  analyticsIsLoaded: false,
  loadingAnalytics: false,

  analyticsChartData: {},
  analyticsChartDataIsLoaded: false,
  loadingAnalyticsChartData: false,

  userAnalytics: {},
  userAnalyticsIsLoaded: false,
  loadingUserAnalytics: false,

  userAnalyticsChartData: {},
  userAnalyticsChartDataIsLoaded: false,
  loadingUserAnalyticsChartData: false,

  accountEquity: {},
  accountEquityIsLoaded: false,
  loadingAccountEquity: false,

  userEquity: {},
  userEquityIsLoaded: false,
  loadingUserEquity: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_DEAL_STATS[REQUEST]:
      return { ...state, dealStatsAreLoaded: false };
    case ActionTypes.GET_DEAL_STATS[SUCCESS]:
      return { ...state, dealStats: action.data, dealStatsAreLoaded: true };
    case ActionTypes.GET_DEAL_STATS[FAILURE]:
      return { ...state, error: action.error, dealStatsAreLoaded: false };

    case ActionTypes.GET_CONVERTATION_OPTIONS[REQUEST]:
      return { ...state, convertationOptionsAreLoaded: false };
    case ActionTypes.GET_CONVERTATION_OPTIONS[SUCCESS]:
      return { ...state, convertationOptions: action.data, convertationOptionsAreLoaded: true };
    case ActionTypes.GET_CONVERTATION_OPTIONS[FAILURE]:
      return { ...state, error: action.error, convertationOptionsAreLoaded: false };

    case ActionTypes.GET_LPA_AGREEMENTS[REQUEST]:
      return { ...state, lpaAgreementsAreLoaded: false };
    case ActionTypes.GET_LPA_AGREEMENTS[SUCCESS]:
      return { ...state, lpaAgreements: action.data.agreements, lpaAgreementsAreLoaded: true };
    case ActionTypes.GET_LPA_AGREEMENTS[FAILURE]:
      return { ...state, error: action.error, lpaAgreementsAreLoaded: false };

    case ActionTypes.GET_OUTER_VERIFY_EXTERNAL_LINK[REQUEST]:
      return { ...state, outerVerifyExternalLinkIsLoaded: false };
    case ActionTypes.GET_OUTER_VERIFY_EXTERNAL_LINK[SUCCESS]:
      return { ...state, outerVerifyExternalLink: action.data, outerVerifyExternalLinkIsLoaded: true };
    case ActionTypes.GET_OUTER_VERIFY_EXTERNAL_LINK[FAILURE]:
      return { ...state, error: action.error, outerVerifyExternalLinkIsLoaded: false };

    case ActionTypes.TRADING_ACCOUNT_IS_CREATED[SUCCESS]:
      return { ...state, createdAccount: action.data };

    case ActionTypes.GET_ACCOUNT_TRADE_LINK[REQUEST]:
      return { ...state, accountTradeLinkLoaded: false, accountTradeLinkLoading: true };
    case ActionTypes.GET_ACCOUNT_TRADE_LINK[SUCCESS]:
      return { ...state, accountTradeLinkLoaded: true, accountTradeLinkLoading: false, accountTradeLink: action.data };
    case ActionTypes.GET_ACCOUNT_TRADE_LINK[FAILURE]:
      return { ...state, error: action.error, accountTradeLinkLoaded: false, accountTradeLinkLoading: false };

    case ActionTypes.GET_ACCOUNT_ANALYTICS[REQUEST]:
      return { ...state, analyticsIsLoaded: false, loadingAnalytics: true };
    case ActionTypes.GET_ACCOUNT_ANALYTICS[SUCCESS]:
      return { ...state, analyticsIsLoaded: true, loadingAnalytics: false, analytics: action.data };
    case ActionTypes.GET_ACCOUNT_ANALYTICS[FAILURE]:
      return { ...state, error: action.error, analyticsIsLoaded: false, loadingAnalytics: false };

    case ActionTypes.GET_ACCOUNT_ANALYTICS_CHART_DATA[REQUEST]:
      return { ...state, analyticsChartDataIsLoaded: false, loadingAnalyticsChartData: true };
    case ActionTypes.GET_ACCOUNT_ANALYTICS_CHART_DATA[SUCCESS]:
      return {
        ...state,
        analyticsChartDataIsLoaded: true,
        loadingAnalyticsChartData: false,
        analyticsChartData: action.data,
      };
    case ActionTypes.GET_ACCOUNT_ANALYTICS_CHART_DATA[FAILURE]:
      return { ...state, error: action.error, analyticsChartDataIsLoaded: false, loadingAnalyticsChartData: false };

    case ActionTypes.GET_ACCOUNT_EQUITY[REQUEST]:
      return { ...state, accountEquityIsLoaded: false, loadingAccountEquity: true };
    case ActionTypes.GET_ACCOUNT_EQUITY[SUCCESS]:
      return { ...state, accountEquityIsLoaded: true, loadingAccountEquity: false, accountEquity: action.data };
    case ActionTypes.GET_ACCOUNT_EQUITY[FAILURE]:
      return { ...state, error: action.error, accountEquityIsLoaded: false, loadingAccountEquity: false };

    case ActionTypes.GET_USER_EQUITY[REQUEST]:
      return { ...state, userEquityIsLoaded: false, loadingUserEquity: true };
    case ActionTypes.GET_USER_EQUITY[SUCCESS]:
      return { ...state, userEquityIsLoaded: true, loadingUserEquity: false, userEquity: action.data };
    case ActionTypes.GET_USER_EQUITY[FAILURE]:
      return { ...state, error: action.error, userEquityIsLoaded: false, loadingUserEquity: false };

    case ActionTypes.GET_USER_ANALYTICS[REQUEST]:
      return { ...state, userAnalyticsIsLoaded: false, loadingUserAnalytics: true };
    case ActionTypes.GET_USER_ANALYTICS[SUCCESS]:
      return { ...state, userAnalyticsIsLoaded: true, loadingUserAnalytics: false, userAnalytics: action.data };
    case ActionTypes.GET_USER_ANALYTICS[FAILURE]:
      return { ...state, error: action.error, userAnalyticsIsLoaded: false, loadingUserAnalytics: false };

    case ActionTypes.GET_USER_ANALYTICS_CHART_DATA[REQUEST]:
      return { ...state, userAnalyticsChartDataIsLoaded: false, loadingUserAnalyticsChartData: true };
    case ActionTypes.GET_USER_ANALYTICS_CHART_DATA[SUCCESS]:
      return {
        ...state,
        userAnalyticsChartDataIsLoaded: true,
        loadingUserAnalyticsChartData: false,
        userAnalyticsChartData: action.data,
      };
    case ActionTypes.GET_USER_ANALYTICS_CHART_DATA[FAILURE]:
      return {
        ...state,
        error: action.error,
        userAnalyticsChartDataIsLoaded: false,
        loadingUserAnalyticsChartData: false,
      };

    default:
      return state;
  }
};

export default reducer;
